<template>
  <!-- eslint-disable -->
<v-container fluid id="DivertedFlightAlerts">
<v-slide-y-transition mode="out-in">
  <div>
    <v-layout wrap>
      <v-flex xs12 sm3>
        <h1>Diverted/Canceled Flight Alerts</h1>
      </v-flex>
      <v-flex xs12 sm9>
        <div style="float: right;">
          <div style="float: left;">
            <div style="float: left; margin-top:10px;">Show flights with any event in the past</div>
            <v-text-field v-model="newHoursPast" type="number" :rules="[rulesInteger]" @keyup.enter="loadFlightAlerts()" class="center-input hoursPastInput" style="float: left; width: 40px; padding: 0; margin: 5px 5px;" @blur="setHoursPast(newHoursPast)"></v-text-field>
            <div style="float: left; margin-top:10px;">hours.</div>
          </div>
          <v-btn dark small class="submitHours" style="margin-left: 15px;" color="grey" @click="loadFlightAlerts()">
            submit
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-progress-linear indeterminate v-show="loading"></v-progress-linear>
    <v-data-table :mobile-breakpoint="0" class="flightTable no-wrap-th" v-if="divertedFlightAlerts.length > 0" disable-pagination hide-default-footer :items="divertedFlightAlerts" item-key="Flight" :headers="headers" :loading="loading">
      <template v-slot:item="{ item }" item-key="HashKey">
        <tr :class="item['Status'] + ' ' + item['Alert']">
          <td>{{item["Alert"]}}</td>
          <td><a class="fa-flight" :href="'https://flightaware.com/live/flight/' + item['Flight']" target="_blank" style="color: black">{{item["Flight"]}}</a></td>
          <td><a class="fa-airport" :href="getHref(item['Origin'])" target="_blank" style="color: black">{{item["Origin"]}}</a></td>
          <td><a class="fa-airport" :href="getHref(item['Actual Dest'])" target="_blank" style="color: black">{{item["Actual Dest"]}}</a></td>
          <td><a class="fa-airport" :href="getHref(item['Original Dest'])" target="_blank" style="color: black">{{item["Original Dest"]}}</a></td>
          <td>{{item["Day"]}}</td>
          <td>{{item["Dep PST"]}}</td>
          <td>{{item["Arr PST"]}}</td>
          <td>{{item["Status"]}}</td>
          <td>{{item["Mins Until Arrival"]}}</td>
          <td class="mins-late" :style="{ 'font-weight': getMinsBold(item['Depart Mins Late']), 'font-size': getMinsFontSize(item['Depart Mins Late'])}" >
            <v-icon v-if="item['Depart Mins Late'] >= 60" :style="{ 'font-size': getAlertSize(item['Depart Mins Late'])}" :color="getAlertColor(item['Depart Mins Late'])" >{{getAlertIcon(item['Depart Mins Late'])}}</v-icon>
            {{item["Depart Mins Late"]}}
          </td>
          <td class="mins-late" :style="{ 'font-weight': getMinsBold(item['Arrival Mins Late']), 'font-size': getMinsFontSize(item['Arrival Mins Late'])}" >
            <v-icon v-if="item['Arrival Mins Late'] >= 60" :style="{ 'font-size': getAlertSize(item['Arrival Mins Late'])}" :color="getAlertColor(item['Arrival Mins Late'])" >{{getAlertIcon(item['Arrival Mins Late'])}}</v-icon>
            {{item["Arrival Mins Late"]}}
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-card v-else>
      <v-card-text>No Flights</v-card-text>
    </v-card>
    <v-card v-if="loading && divertedFlightAlerts.length > 0">
      <v-card-text>Loading flights. . .</v-card-text>
    </v-card>
  </div>
</v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import flightsModule, { FLIGHTS_NAMESPACE } from "./store/flightsStore";
import { mapGetters } from "vuex";
import FlightAlertsMixin from "@/mixins/FlightAlertsMixin.js";
import RulesMixin from "@/mixins/RulesMixin.js";
export default {
  name: "DivertedFlightAlerts",
  mixins: [RulesMixin, FlightAlertsMixin],
  data() {
    return {
      newHoursPast: "",
      headers: [
        {
          text: "Alert",
          sortable: true,
          align: "left",
          value: "Alert"
        },
        {
          text: "Flight",
          sortable: true,
          align: "left",
          value: "Flight"
        },
        {
          text: "Origin",
          sortable: true,
          align: "left",
          value: "Origin"
        },
        {
          text: "Actual Dest.",
          sortable: true,
          align: "left",
          value: "Actual Dest"
        },
        {
          text: "Original Dest.",
          sortable: true,
          align: "left",
          value: "Original Dest"
        },
        {
          text: "Day",
          sortable: true,
          align: "left",
          value: "Day"
        },
        {
          text: "Depart. PST",
          sortable: true,
          align: "left",
          value: "Dep PST"
        },
        {
          text: "Arrival PST",
          sortable: true,
          align: "left",
          value: "Arr PST"
        },
        {
          text: "Status",
          sortable: true,
          align: "left",
          value: "Status"
        },
        {
          text: "Mins. to Arrival",
          sortable: true,
          align: "left",
          value: "Mins Until Arrival"
        },
        {
          text: "Depart. Mins. Late",
          sortable: true,
          align: "left",
          value: "Depart Mins Late"
        },
        {
          text: "Arrival Mins. Late",
          sortable: true,
          align: "left",
          value: "Arrival Mins Late"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(FLIGHTS_NAMESPACE, [
      "divertedFlightAlerts",
      "loading",
      "divertedHoursPast"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(FLIGHTS_NAMESPACE, flightsModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.FLIGHTS_ADMIN]).then(
      res => {
        if (res) {
          this.newHoursPast = this.divertedHoursPast;
          this.loadFlightAlerts();
        } else this.$goHome();
      }
    );
  },
  methods: {
    loadFlightAlerts() {
      return this.$store.dispatch(
        `${FLIGHTS_NAMESPACE}/loadDivertedFlightAlerts`
      );
    },
    setHoursPast(hours) {
      if (!isNaN(parseInt(hours)))
        this.$store.dispatch(
          `${FLIGHTS_NAMESPACE}/setDivertedHoursPast`,
          hours
        );
    },
    getHref(alert) {
      if ((alert + "").indexOf("(") > -1)
        return (
          "https://flightaware.com/live/airport/" +
          alert.substring(0, alert.indexOf("(") - 1)
        );
    }
  }
};
</script>
